import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './call/HttpClientCall.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { defaultTransformers2r9wd7ftt31zw as defaultTransformers } from './plugins/DefaultTransform.mjs';
import {
  get_HttpResponseReceiveFailed2q0s5em07bm9j as get_HttpResponseReceiveFailed,
  HttpResponseReceiveFailk4vfmxmwithf as HttpResponseReceiveFail,
  get_HttpRequestCreated2xa7wfn254wyu as get_HttpRequestCreated,
} from './utils/ClientEvents.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from './HttpClientConfig.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Key_instancepi2bbb0csu5f as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  HttpRequestPipeline1v7xct5dgezuy as HttpRequestPipeline,
  HttpSendPipeline3tm1hram7cjxt as HttpSendPipeline,
  Phases_getInstance2rx62p874ogj4 as Phases_getInstance,
} from './request/HttpRequestPipeline.mjs';
import {
  HttpResponsePipeline14ucx7kbf4hm2 as HttpResponsePipeline,
  HttpReceivePipeline1ousblrss634z as HttpReceivePipeline,
  Phases_getInstance39l8b4mzhgwzm as Phases_getInstance_0,
} from './statement/HttpResponsePipeline.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { Events63tfxre48w4z as Events } from '../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { get_HttpRequestLifecycle1e7j0z243lnj5 as get_HttpRequestLifecycle } from './plugins/HttpRequestLifecycle.mjs';
import { get_BodyProgresstom4nhodv8bj as get_BodyProgress } from './plugins/BodyProgress.mjs';
import { get_SaveBody3aignvhtsnvcr as get_SaveBody } from './plugins/SaveBody.mjs';
import { Plugin_getInstancedvtd2m29fslb as Plugin_getInstance } from './plugins/HttpSend.mjs';
import { get_HttpCallValidator3iji36qylbtbr as get_HttpCallValidator } from './plugins/HttpCallValidator.mjs';
import { get_HttpRedirect1lgx3wewnhrb0 as get_HttpRedirect } from './plugins/HttpRedirect.mjs';
import { get_HttpPlainText2hd9sygnz4kij as get_HttpPlainText } from './plugins/HttpPlainText.mjs';
import { addDefaultResponseValidation1d06vtgr9flaj as addDefaultResponseValidation } from './plugins/DefaultResponseValidation.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from './engine/HttpClientEngineBase.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { cancel36mj9lv3a0whl as cancel } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpClient$slambda(this$0) {
  return constructCallableReference(($this$intercept, call, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.check' call
    if (!(call instanceof HttpClientCall())) {
      var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
    }
    var response = yield* this$0.receivePipeline_1.execute_qsx0hz_k$(Unit_instance, call.get_response_xlk07e_k$(), $completion);
    call.setResponse_4r46xy_k$(response);
    yield* $this$intercept.proceedWith_i5skhv_k$(call, $completion);
    return Unit_instance;
  }), 2);
}
function HttpClient$lambda($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
function HttpClient$slambda_0(this$0) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    try {
      yield* $this$intercept.proceed_tynop7_k$($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        this$0.monitor_1.raise_3e7w7u_k$(get_HttpResponseReceiveFailed(), new (HttpResponseReceiveFail())($this$intercept.context_1.get_response_xlk07e_k$(), cause));
        throw cause;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 2);
}
var HttpClientClass;
function HttpClient() {
  if (HttpClientClass === VOID) {
    class $ {
      constructor(engine, userConfig) {
        return new.target.new_io_ktor_client_HttpClient_17i9z2_k$(engine, userConfig);
      }
      static new_io_ktor_client_HttpClient_17i9z2_k$(engine, userConfig) {
        userConfig = userConfig === VOID ? new (HttpClientConfig())() : userConfig;
        var $this = createThis(this);
        $this.engine_1 = engine;
        $this.userConfig_1 = userConfig;
        $this.manageEngine_1 = false;
        $this.closed_1 = atomic$boolean$1(false);
        $this.clientJob_1 = Job($this.engine_1.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance));
        $this.coroutineContext_1 = $this.engine_1.get_coroutineContext_115oqo_k$().plus_s13ygv_k$($this.clientJob_1);
        $this.requestPipeline_1 = new (HttpRequestPipeline())();
        $this.responsePipeline_1 = new (HttpResponsePipeline())();
        $this.sendPipeline_1 = new (HttpSendPipeline())();
        $this.receivePipeline_1 = new (HttpReceivePipeline())();
        $this.attributes_1 = AttributesJsFn(true);
        $this.engineConfig_1 = $this.engine_1.get_config_c0698r_k$();
        $this.monitor_1 = new (Events())();
        $this.config_1 = new (HttpClientConfig())();
        $this.engine_1.install_se0ieo_k$($this);
        var tmp = Phases_getInstance().Receive_1;
        $this.sendPipeline_1.intercept_k21bv3_k$(tmp, HttpClient$slambda($this));
        // Inline function 'kotlin.with' call
        var $this$with = $this.userConfig_1;
        $this.config_1.install$default_lc5jjj_k$(get_HttpRequestLifecycle());
        $this.config_1.install$default_lc5jjj_k$(get_BodyProgress());
        $this.config_1.install$default_lc5jjj_k$(get_SaveBody());
        if ($this$with.useDefaultTransformers_1) {
          $this.config_1.install_vucysr_k$('DefaultTransformers', HttpClient$lambda);
        }
        $this.config_1.install$default_lc5jjj_k$(Plugin_getInstance());
        $this.config_1.install$default_lc5jjj_k$(get_HttpCallValidator());
        if ($this$with.followRedirects_1) {
          $this.config_1.install$default_lc5jjj_k$(get_HttpRedirect());
        }
        $this.config_1.plusAssign_xm1izo_k$($this$with);
        if ($this$with.useDefaultTransformers_1) {
          $this.config_1.install$default_lc5jjj_k$(get_HttpPlainText());
        }
        addDefaultResponseValidation($this.config_1);
        $this.config_1.install_se0ieo_k$($this);
        var tmp_0 = Phases_getInstance_0().Receive_1;
        $this.responsePipeline_1.intercept_k21bv3_k$(tmp_0, HttpClient$slambda_0($this));
        return $this;
      }
      static new_io_ktor_client_HttpClient_5k5wf9_k$(engine, userConfig, manageEngine) {
        var $this = this.new_io_ktor_client_HttpClient_17i9z2_k$(engine, userConfig);
        $this.manageEngine_1 = manageEngine;
        if ($this.manageEngine_1) {
          if (engine instanceof HttpClientEngineBase()) {
            engine.clientRefCount_1.atomicfu$incrementAndGet();
          }
          var tmp = ensureNotNull($this.coroutineContext_1.get_y2st91_k$(Key_instance));
          tmp.invokeOnCompletion_n6cffu_k$((cause) => {
            var tmp;
            if (!(engine instanceof HttpClientEngineBase())) {
              tmp = true;
            } else {
              tmp = engine.clientRefCount_1.atomicfu$decrementAndGet() <= 0;
            }
            var shouldClose = tmp;
            var tmp_0;
            if (shouldClose) {
              var tmp_1;
              if (cause == null) {
                engine.close_yn9xrc_k$();
                tmp_1 = Unit_instance;
              } else {
                var tmp0_elvis_lhs = cause instanceof CancellationException() ? cause : null;
                cancel(engine, tmp0_elvis_lhs == null ? CancellationException().new_kotlin_coroutines_cancellation_CancellationException_cpsifs_k$('Client scope is canceled', cause) : tmp0_elvis_lhs);
                tmp_1 = Unit_instance;
              }
              tmp_0 = tmp_1;
            }
            return Unit_instance;
          });
        }
        return $this;
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      *execute_f9smnw_k$(builder, $completion) {
        this.monitor_1.raise_3e7w7u_k$(get_HttpRequestCreated(), builder);
        var tmp = yield* this.requestPipeline_1.execute_qsx0hz_k$(builder, builder.body_1, $completion);
        return tmp instanceof HttpClientCall() ? tmp : THROW_CCE();
      }
      close_yn9xrc_k$() {
        var success = this.closed_1.atomicfu$compareAndSet(false, true);
        if (!success)
          return Unit_instance;
        var installedFeatures = this.attributes_1.get_r696p5_k$(get_PLUGIN_INSTALLED_LIST());
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = installedFeatures.get_allKeys_dton90_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var plugin = installedFeatures.get_r696p5_k$(element instanceof AttributeKey() ? element : THROW_CCE());
          if (isInterface(plugin, AutoCloseable())) {
            plugin.close_yn9xrc_k$();
          }
        }
        this.clientJob_1.complete_9ww6vb_k$();
      }
      toString() {
        return 'HttpClient[' + toString(this.engine_1) + ']';
      }
    }
    initMetadataForClass($, 'HttpClient', VOID, VOID, [AutoCloseable()], [1]);
    HttpClientClass = $;
  }
  return HttpClientClass;
}
function HttpClient_0(engine, block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  return HttpClient().new_io_ktor_client_HttpClient_5k5wf9_k$(engine, this_0, false);
}
function HttpClient_1(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.create_kry9d7_k$(config.engineConfig_1);
  return HttpClient().new_io_ktor_client_HttpClient_5k5wf9_k$(engine, config, true);
}
function HttpClient$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  HttpClient_0 as HttpClienthpouyso1j6ge,
  HttpClient_1 as HttpClient2x7qc5z8fmeal,
};
//endregion

//# sourceMappingURL=HttpClient.mjs.map
